module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleClick($event)
      }
    },
    model: {
      value: (_vm.model),
      callback: function($$v) {
        _vm.model = $$v
      },
      expression: "model"
    }
  }, [_c('a', [_vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.isActive) ? _c('i', {
    staticClass: "fa fa-check pos-abs pos-r-sm tex-small m-t-xs sort-by-check inline"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4369719c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/FiltroStatusItem.vue
// module id = 1623
// module chunks = 17